import { ExitRunIcon } from './ExitRunIcon';

/**
 * author: Simran
 * id 9F68722F-B500-48AD-BE3A-EB7591496084
 * name exit-run
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exit-run.svg
 * tags
 * - Home Automation 
 */
export const EmergencyExitIcon = ExitRunIcon;
export default EmergencyExitIcon